import { SecLoanApplicationType, SecLoanPurposeType } from '@shared/sec-loans'
import { ExitUrls } from '@shared/types'

export type { User } from '@sec-loans-ui/wizard/types'

export enum ApplicationType {
  LoanApplication = 'loan',
  InstalmentFreePeriodApplication = 'ifp',
}

export interface AuthenticatedContext {
  authToken: string
  exitUrls: ExitUrls
}

export interface SecLoansApplicationSelectData {
  applicationType: SecLoanApplicationType
  applicationPurpose: SecLoanPurposeType
}

export type ApplicationSelectData =
  | {
      applicationId: string
      applicationType: ApplicationType.LoanApplication
      data: SecLoansApplicationSelectData
    }
  | {
      applicationId: string
      applicationType: ApplicationType.InstalmentFreePeriodApplication
    }
